"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.insertItemsInArray = exports.insertItemInArray = exports.updateObjectInArray = exports.getPropKeyByValue = exports.isSafariBrowser = exports.isIE11 = exports.deleteCookie = exports.setCookie = exports.getCookie = exports.setUpPropsByDevice = exports.getCurrentLocationProps = exports.getDeviceKindDependsOnViewPort = exports.getViewPortSize = exports.getDeviceInfo = exports.makeRequest = exports.HEADERS = exports.toKebabCase = exports.getUrlParams = exports.cleanUnAllowedKeysInsideObject = exports.makeUpObj = exports.myAssign = exports.generateComponentId = exports.giveRandomNumber = void 0;

var _queryString = _interopRequireDefault(require("query-string"));

var _gerenciatdUtils = require("@bit/gerenciatd.utils.log-utils");

var _deepmerge = _interopRequireDefault(require("deepmerge"));

var _constants = require("../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* COMMONS */

/* calculate random number from min to max both limits included */
const giveRandomNumber = (min, max) => Math.floor(Math.random() * max) + min;
/* generate componnntId string using componentName, aditional id or optinal id */


exports.giveRandomNumber = giveRandomNumber;

const generateComponentId = (componentName, aditionalId = '', id = giveRandomNumber(1, 999)) => `${componentName}-${id}${aditionalId ? `-${aditionalId}` : ''}`;
/**
 * myAssign
 * @param {object} obj object where you desire to assing something
 * @param {string} keyPath path inside object whete you want to place it like: info.data already splited by .
 * @param {string||number} value value to associate
 * @returns {object} for example: {href: 'https://www.movistar.es', referrer: 'https://www.google.com'}
 */


exports.generateComponentId = generateComponentId;

const myAssign = (obj, keyPath, value) => {
  const lastKeyIndex = keyPath.length - 1;

  for (let i = 0; i < lastKeyIndex; i += 1) {
    const key = keyPath[i];

    if (!(key in obj)) {
      obj[key] = {};
    }

    obj = obj[key];
  }

  if (typeof value === 'object') {
    obj[keyPath[lastKeyIndex]] = _objectSpread(_objectSpread({}, obj[keyPath[lastKeyIndex]]), value);
  } else {
    obj[keyPath[lastKeyIndex]] = value;
  }
};
/**
 * makeUpObj
 * @param {object} objRes object used to write the final result
 * @param {string} key path inside object whete you want to place it like: info.data
 * @param {string||number} value value to associate
 * @returns {object} for example: {href: 'https://www.movistar.es', referrer: 'https://www.google.com'}
 */


exports.myAssign = myAssign;

const makeUpObj = (objRes, key, value) => {
  const finalObjRes = _objectSpread({}, objRes);

  const tokkens = key.indexOf('.') > 0 ? key.split('.') : [key];
  myAssign(finalObjRes, tokkens, value);
  return finalObjRes;
};
/**
 * cleanUnAllowedKeysInsideObject
 * @param {object} object2Clean object to clean
 * @param {array} allowedKeys array of RegEx like: allowed: []
 * @param {string||number} value value to associate
 * @returns {object} for example: {href: 'https://www.movistar.es', referrer: 'https://www.google.com'}
 */


exports.makeUpObj = makeUpObj;

const cleanUnAllowedKeysInsideObject = (object2Clean, allowedKeys) => {
  const newObjectCleaned = _objectSpread({}, object2Clean); // looping


  const keys = Object.keys(object2Clean);
  keys.forEach(key => {
    let allowed = false;
    allowedKeys.forEach(regItem => {
      const regEx = new RegExp(regItem);

      if (regEx.test(key) && !allowed) {
        allowed = true;
      }
    });

    if (!allowed) {
      delete newObjectCleaned[key];
    }
  });
  return newObjectCleaned;
};
/* Get all params on the current url like ?prod=producto&test="ok" */
// groupByObject means if keys like context.subseg and context.priority are found
// those will be group inside context object like: { priority, subseg }
// allowedParams (ARRAY OF REGEX like  [/prodCode/g ]) it will helps to clean unwanted params.

/**
 * getUrlParams
 * @param {bool} groupByObject object used to write the final result
 * @param {array} allowedKeys array of RegEx like: allowed: []
 * @returns {object} for example: {href: 'https://www.movistar.es', referrer: 'https://www.google.com'}
 */


exports.cleanUnAllowedKeysInsideObject = cleanUnAllowedKeysInsideObject;

const getUrlParams = (groupByObject = false, allowedParams = null) => {
  let params = null;

  try {
    // detecting if we have # has router
    const hashInfo = !!window.location.hash;
    const searchParams = !!window.location.search;
    const hashRouterParasm = hashInfo && !searchParams && window.location.hash.indexOf('?') > -1;

    if (hashRouterParasm) {
      const beginPosition = window.location.hash.indexOf('?');
      const string2Analise = window.location.hash.substr(beginPosition);
      params = _queryString.default.parse(string2Analise);
    } else {
      params = _queryString.default.parse(window.location.search);
    }
  } catch (err) {// errorLog('Error on [getUrlParams] in jsUtils file');
  } // cleaning function


  if (Array.isArray(allowedParams) && params) {
    params = cleanUnAllowedKeysInsideObject(params, allowedParams);
  } // groupby . as object


  if (groupByObject) {
    let groupuedParams = {};
    const paramsKeys = Object.keys(params);
    paramsKeys.forEach(paramsKey => {
      const value = params[paramsKey];

      if (paramsKey.indexOf('.') !== -1) {
        groupuedParams = makeUpObj(groupuedParams, paramsKey, value);
      } else {
        groupuedParams[paramsKey] = value;
      }
    });
    params = groupuedParams;
  }

  return params;
};
/**
 * Convierte a kebab case una cadena.
 * @param {String} cadena a transformar.
 */


exports.getUrlParams = getUrlParams;

const toKebabCase = entry => {
  let kebapName = entry.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, '$1-$2').toLowerCase();

  if (kebapName[0] === '-') {
    kebapName = kebapName.substr(1);
  }

  return kebapName;
}; // usefull if we desire DEFAULT HEADERS


exports.toKebabCase = toKebabCase;
const HEADERS = {
  timeout: 50000
};
/* DEPRECATED: USE NEW UTILS.REQUEST */

exports.HEADERS = HEADERS;

const makeRequest = (method = 'GET', endpoint, data, onError, onSuccess, onFetching, headers = null, dataStringify = true, responseChecking = true) => {
  let headers2Use = _objectSpread({}, HEADERS);

  if (!endpoint) {
    (0, _gerenciatdUtils.errorLog)('[makeRequest]: endpoint prop can not be undefined');
    return null;
  }

  if (!onError || !onSuccess || !onFetching) {
    (0, _gerenciatdUtils.warnLog)('[makeRequest]: It is recomended use prop functions: onError, onSuccess, onFetching for normalizing data', 'MakeRequest-event-methods');
  }

  if (headers2Use) {
    headers2Use = _objectSpread(_objectSpread({}, HEADERS), headers);
  } // CHEECKING ENDS


  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest(); // error handling

    const errorHandler = (errorStringName = 'Generic Error', currentXhr = null) => {
      let onErrorObj = {
        status: 500,
        statusText: errorStringName
      };

      if (onError && currentXhr) {
        const onErrorAux = onError(currentXhr);

        if (onErrorAux) {
          onErrorObj = onErrorAux;
        }
      }

      const errorRes = onErrorObj;
      reject(errorRes);
    }; // cleaning response


    const cleanResponse = response => {
      let finalResponse = response; // Para casos en que devuelve un html o un string que no es un json

      if (responseChecking) {
        if (typeof response === 'string') {
          finalResponse = finalResponse.trim();

          try {
            finalResponse = JSON.parse(finalResponse);
          } catch (err) {
            finalResponse = null;
          }
        }
      }

      return finalResponse;
    };

    xhr.open(method, endpoint, true);
    /*  applying headers */

    const headerKeys = Object.keys(headers2Use);
    headerKeys.forEach(headerKey => {
      const value = headers2Use[headerKey];

      if (headerKey === 'withCredentials') {
        xhr.withCredentials = value;
      } else if (headerKey === 'timeout') {
        xhr.timeout = value;
      } else {
        xhr.setRequestHeader(`${headerKey}`, value);
      }
    });

    if (onFetching) {
      onFetching();
    }

    xhr.onload = () => {
      const myResponse = cleanResponse(xhr.response); // const myResponse = cleanResponse(' ');
      // aqui podriamos comprobar si response no es null

      if (xhr.status >= 200 && xhr.status < 300 && myResponse) {
        /*
         si retorna obj significa que es un normalizador,
         en caso contrario solo monitoriza y retorno su response
        */
        let onSuccessObj = null;

        if (onSuccess) {
          onSuccessObj = onSuccess(xhr);
        }

        const res = onSuccessObj || myResponse;
        resolve(res);
      } else if (!myResponse || !xhr.response) {
        // aquí no envio el xhr porque posiblemente diga que esta OK y no es verdad
        errorHandler('Response json bad structure  or empty', {
          status: 500,
          statusText: 'Response json bad structure  or empty'
        });
      } else {
        // Este es el unico al que no hay que hacerle un xhr ficticio
        errorHandler(xhr.statusText, xhr);
      }
    }; // ONERROR


    xhr.onerror = () => {
      const statusText = 'Network Error';
      errorHandler(statusText, {
        status: 500,
        statusText
      });
    }; // ONTIMEOUT


    xhr.ontimeout = () => {
      const statusText = `Timeout Error${headers2Use && headers2Use.timeout ? `: ${headers2Use.timeout}ms` : ''}`;
      errorHandler(statusText, {
        status: 500,
        statusText
      });
    }; // SEND INFO


    if (data) {
      if (dataStringify) {
        xhr.send(JSON.stringify(data));
      } else {
        xhr.send(data);
      }
    } else {
      xhr.send();
    }
  });
};
/**
 * detect info about where and how the page is executed
 * output example:
 * {
 *  "os":{"name":"Windows","version":10},
 *  "browser":{"name":"Chrome","version":80.03987149},
 *  "navigator":{
 *    "userAgent":"Mozilla/5.0 (Windows NT 10.0; Win64; x64)
 *     AppleWebKit/537.36 (KHTML, like Gecko) Chrome/80.0.3987.149 Safari/537.36",
 *    "appVersion":"5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko)
 *     Chrome/80.0.3987.149 Safari/537.36",
 *    "platform":"Win32","vendor":"Google Inc."
 *   }
 * }
 * @returns {object} for example: {href: 'https://www.movistar.es', referrer: 'https://www.google.com'}
 */


exports.makeRequest = makeRequest;

const getDeviceInfo = () => {
  const module = {
    options: [],
    header: [navigator.platform, navigator.userAgent, navigator.appVersion, navigator.vendor],
    dataos: [{
      name: 'Windows Phone',
      value: 'Windows Phone',
      version: 'OS'
    }, {
      name: 'Windows',
      value: 'Win',
      version: 'NT'
    }, {
      name: 'iPhone',
      value: 'iPhone',
      version: 'OS'
    }, {
      name: 'iPad',
      value: 'iPad',
      version: 'OS'
    }, {
      name: 'Kindle',
      value: 'Silk',
      version: 'Silk'
    }, {
      name: 'Android',
      value: 'Android',
      version: 'Android'
    }, {
      name: 'PlayBook',
      value: 'PlayBook',
      version: 'OS'
    }, {
      name: 'BlackBerry',
      value: 'BlackBerry',
      version: '/'
    }, {
      name: 'Macintosh',
      value: 'Mac',
      version: 'OS X'
    }, {
      name: 'Linux',
      value: 'Linux',
      version: 'rv'
    }, {
      name: 'Palm',
      value: 'Palm',
      version: 'PalmOS'
    }],
    databrowser: [{
      name: 'Chrome',
      value: 'Chrome',
      version: 'Chrome'
    }, {
      name: 'Firefox',
      value: 'Firefox',
      version: 'Firefox'
    }, {
      name: 'Safari',
      value: 'Safari',
      version: 'Version'
    }, {
      name: 'Internet Explorer',
      value: 'MSIE',
      version: 'MSIE'
    }, {
      name: 'Opera',
      value: 'Opera',
      version: 'Opera'
    }, {
      name: 'BlackBerry',
      value: 'CLDC',
      version: 'CLDC'
    }, {
      name: 'Mozilla',
      value: 'Mozilla',
      version: 'Mozilla'
    }]
  };

  const matchItem = (string, data) => {
    let i = 0;
    let j = 0;
    let regex;
    let regexv;
    let match;
    let matches;
    let version;

    for (i = 0; i < data.length; i += 1) {
      regex = new RegExp(data[i].value, 'i');
      match = regex.test(string);

      if (match) {
        regexv = new RegExp(`${data[i].version}[- /:;]([\\d._]+)`, 'i');
        matches = string.match(regexv);
        version = '';

        if (matches) {
          if (matches[1]) {
            matches = matches[1];
          }
        }

        if (matches) {
          matches = matches.split(/[._]+/);

          for (j = 0; j < matches.length; j += 1) {
            if (j === 0) {
              version += `${matches[j]}.`;
            } else {
              version += matches[j];
            }
          }
        } else {
          version = '0';
        }

        return {
          name: data[i].name,
          version: parseFloat(version)
        };
      }
    }

    return {
      name: 'unknown',
      version: 0
    };
  };

  const init = () => {
    const agent = module.header.join(' ');
    const os = matchItem(agent, module.dataos);
    const browser = matchItem(agent, module.databrowser);
    const navigatorData = {
      userAgent: navigator.userAgent,
      appVersion: navigator.appVersion,
      platform: navigator.platform,
      vendor: navigator.vendor
    };
    return {
      os,
      browser,
      navigator: navigatorData
    };
  };

  const info = init();
  return info;
};
/* getViewPortSize */


exports.getDeviceInfo = getDeviceInfo;

const getViewPortSize = () => {
  let viewPortWidth;
  let viewPortHeight;
  let clientWidth = 1000;
  let clientHeight = 600;

  try {
    ({
      clientWidth
    } = document.getElementsByTagName('body')[0]);
    ({
      clientHeight
    } = document.getElementsByTagName('body')[0]);
  } catch (err) {// we have tryied get values
  }
  /* the more standards compliant browsers (mozilla/netscape/opera/IE7)
  use window.innerWidth and window.innerHeight */


  if (window.innerWidth) {
    viewPortWidth = window.innerWidth;
    viewPortHeight = window.innerHeight;
  } // IE6 in standards compliant mode (i.e. with a valid doctype as the first line in the document)
  else if (document.documentElement && document.documentElement.clientWidth && document.documentElement.clientWidth !== 0) {
    viewPortWidth = document.documentElement.clientWidth;
    viewPortHeight = document.documentElement.clientHeight;
  } else {
    viewPortWidth = clientWidth;
    viewPortHeight = clientHeight;
  }

  return {
    viewPortWidth,
    viewPortHeight
  };
};
/* getKindDeviceByViewportSize */


exports.getViewPortSize = getViewPortSize;

const getDeviceKindDependsOnViewPort = () => {
  const {
    viewPortWidth
  } = getViewPortSize();
  let res = _constants.DEVICES.MOBILE;

  if (viewPortWidth >= 980) {
    res = _constants.DEVICES.PC;
  }

  if (viewPortWidth >= 768 && viewPortWidth < 980) {
    res = _constants.DEVICES.TABLET;
  }

  return res;
};
/**
 * get info about url and document
 * @returns {object} for example: {href: 'https://www.movistar.es', referrer: 'https://www.google.com'}
 */


exports.getDeviceKindDependsOnViewPort = getDeviceKindDependsOnViewPort;

const getCurrentLocationProps = () => {
  const res = {
    href: '',
    referrer: ''
  };
  /* Getting href */

  try {
    res.href = window.location.href;
  } catch (err) {
    (0, _gerenciatdUtils.errorLog)('Could not acces to window.location.href');
  }
  /* Getting referrer */


  try {
    res.referrer = document.referrer;
  } catch (err) {
    (0, _gerenciatdUtils.errorLog)('Could not acces to document.referrer');
  }

  return res;
};
/**
 * Mergea las propiedades de desktop y/o tablet basándose en el device del cliente
 */


exports.getCurrentLocationProps = getCurrentLocationProps;

const setUpPropsByDevice = props => {
  let result = _objectSpread({}, props);

  const {
    desktopProps,
    tabletProps
  } = props;

  if (props && (desktopProps || tabletProps)) {
    const device = getDeviceKindDependsOnViewPort();

    if (device && device !== _constants.DEVICES.MOBILE) {
      if (device === _constants.DEVICES.PC) {
        if (tabletProps) {
          result = (0, _deepmerge.default)(result, tabletProps);
        }

        if (desktopProps) {
          result = (0, _deepmerge.default)(result, desktopProps);
        }
      } else if (device === _constants.DEVICES.TABLET) {
        if (tabletProps) {
          result = (0, _deepmerge.default)(result, tabletProps);
        }
      }
    }
  }

  if (result.desktopProps) {
    delete result.desktopProps;
  }

  if (result.tabletProps) {
    delete result.tabletProps;
  }

  return result;
};

exports.setUpPropsByDevice = setUpPropsByDevice;

const getCookie = cName => {
  let cValue = document && document.cookie ? document.cookie : '';

  if (cValue) {
    let cStart = cValue.indexOf(` ${cName}=`);

    if (cStart === -1) {
      cStart = cValue.indexOf(`${cName}=`);
    }

    if (cStart === -1) {
      cValue = null;
    } else {
      cStart = cValue.indexOf('=', cStart) + 1;
      let cEnd = cValue.indexOf(';', cStart);

      if (cEnd === -1) {
        cEnd = cValue.length;
      }

      cValue = unescape(cValue.substring(cStart, cEnd));
    }
  }

  return cValue;
};

exports.getCookie = getCookie;

const setCookie = (cName, value, exdays, domain = '', needScape = true) => {
  const exdate = new Date();
  exdate.setDate(exdate.getDate() + exdays);
  let cValue = null;
  const parsedValue = needScape ? escape(value) : value;

  if (!domain) {
    cValue = parsedValue + (exdays === null ? '' : `;expires=${exdate.toUTCString()};path=/`);
  } else {
    cValue = parsedValue + (exdays === null ? '' : `;expires=${exdate.toUTCString()};domain=${domain};path=/`);
  }

  document.cookie = `${cName}=${cValue}`;
};

exports.setCookie = setCookie;

const deleteCookie = name => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/`;
};

exports.deleteCookie = deleteCookie;

const isIE11 = () => {
  let res = false;

  if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1) {
    res = true;
  }

  return res;
};

exports.isIE11 = isIE11;

const isSafariBrowser = () => {
  let res = false;

  try {
    const ua = navigator.userAgent.toLowerCase();

    if (ua.indexOf('safari') !== -1) {
      if (!(ua.indexOf('chrome') > -1)) {
        res = true;
      }
    }
  } catch (err) {
    /* console.log('something failed on this browser'); */
  }

  return res;
};
/**
 * Method that searches for the key corresponding to a certain value
 * @param {object} object - Object to make search
 * @param {any} value - Value to search his key
 */


exports.isSafariBrowser = isSafariBrowser;

const getPropKeyByValue = (object, value) => {
  let res = null;

  if (typeof object === 'object' && value) {
    res = Object.keys(object).find(key => object[key] === value);
  }

  (0, _gerenciatdUtils.errorLog)('{getPropKeyByValue}: Object undefined or not received value to search', 'getPropKeyByValue1');
  return res;
};
/**
 * Return immutable update of one element on received array
 * @param {array} array - Original array
 * @param {number} index - Index of new item values on received array
 * @param {object} newItemValues - New item values
 */


exports.getPropKeyByValue = getPropKeyByValue;

const updateObjectInArray = (array, itemIndex, newItemValues) => {
  return array.map((item, index) => {
    if (index !== itemIndex) {
      return item;
    }

    return _objectSpread(_objectSpread({}, item), newItemValues);
  });
};
/**
 * Return immutable addition of one element on received array
 * @param {array} array - Original array
 * @param {number} index - Position where newItem will be added
 * @param {object} newItem - New item of array
 */


exports.updateObjectInArray = updateObjectInArray;

const insertItemInArray = (array, index, newItem) => {
  const newArray = array.slice();
  newArray.splice(index, 0, newItem);
  return newArray;
};
/**
 * Return immutable addition of multiple items
 * @param {array} array - Original array
 * @param {array} newItems - Array of new items
 */


exports.insertItemInArray = insertItemInArray;

const insertItemsInArray = (array, newItems) => {
  const newArray = array.slice();
  newItems.forEach(item => {
    newArray.splice(newArray.length, 0, item);
  });
  return newArray;
};

exports.insertItemsInArray = insertItemsInArray;

//# sourceMappingURL=index.js.map